module.exports = __webpack_public_path__ + "img/ring_y_i_null_1@2x.ffcf48d0.png";